module.exports = __webpack_public_path__ + "static/media/JM.2fbfcbf1.svg";